module.exports = "<svg viewBox=\"0 0 24 24\"><circle cx=\"12\" cy=\"8\" r=\"7\"/><polyline points=\"8.21 13.89 7 23 12 20 17 23 15.79 13.88\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/icons/award.svg
// module id = 1W9C
// module chunks = 0